module.exports = __webpack_public_path__ + "images/6beaaf936ca647290ada8461da749c53.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-miniposter.jpg
// module id = ./webpack/assets/img/wheels-miniposter.jpg
// module chunks = 0